import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { i18n } from 'src/i18n';
import { bigTvImageProps } from 'src/resources/images';

export const PageWrongTvPlatform: FC = () => (
  <CommonError
    title={i18n.page.error.wrongTvPlatform.title}
    subtitle={i18n.page.error.wrongTvPlatform.description}
    image={bigTvImageProps}
  />
);
